import { render, staticRenderFns } from "./VersionSwitcher.vue?vue&type=template&id=320c8b55&scoped=true"
import script from "./VersionSwitcher.vue?vue&type=script&lang=js"
export * from "./VersionSwitcher.vue?vue&type=script&lang=js"
import style0 from "./VersionSwitcher.vue?vue&type=style&index=0&id=320c8b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c8b55",
  null
  
)

export default component.exports